import React from 'react'
import '../styles/containerSection3.css'


function SectionComp3() {
    return (
        <div className='container_section3 container-xxl mt-5 pt-4 pb-4 mb-1'>

            <div className='containerSection13'><img src={`${process.env.PUBLIC_URL}/img/abg/FleanceVelasquez.png`} alt="Descripción de la imagen" className="imagen-ajustada"></img>
            </div>

            <div className='col-lg-5 d-flex flex-column sectiona'>
                <h1 className='section1-tittle3'>Más que un servicio</h1>
                <h1 className='section1-tittle-23'>Somos tu blindaje <span className='fw-bold'>jurídico</span></h1>
                <p className='section1-tittle-3'>
                    <span className='fw-bold section1-tittle-4'>En DEFIENDEME </span>
                    Nos diferenciamos por ofrecer tranquilidad total a
                    nuestros clientes, permitiéndoles concentrarse en sus
                    prioridades mientras nosotros nos encargamos de los
                    aspectos legales. Cuentas con un
                    aliado estratégico para tu protección</p>
                <h1 className='section1-tittle-53 fw-bold'>¡Tu bienestar legal es nuestra prioridad!</h1>

            </div>



        </div>
    )
}

export default SectionComp3
